/**
 * CONTRATO DIGITAL: AS CLÁUSULAS DE VALOR (pedido do Heitor, 28/10/2026, visto no contrato 56 da PRO20260093).
 *
 * (a) Moeda. O backend devolve `totalPS`/`totalMRR` como texto ("1220.00", `numeric` do Postgres), e
 * `"1220.00".toLocaleString('pt-BR', …)` devolve a própria string: saía "R$ 1220.00" na 2.2 e "R$ 0.00" na 2.1. Foram 27
 * dos 29 contratos digitais (24 assinados). A prévia do modelo em Templates não mostrava porque o exemplo é número.
 *
 * (b) P&S zero. A 2.1 do modelo é uma frase só ("pago em N parcelas…"), sem como dizer "isento". Quem renderiza decide:
 * com P&S zero, a 2.1 vira a frase do Heitor, sem parcelas nem vencimento. A frase do modelo é reconhecida como está
 * gravada hoje; quem quiser pode trocá-la no modelo pela variável `{{ oportunidade.proposta.clausulaPS }}`, que dá o
 * mesmo resultado.
 */
import { fmtCurrency } from './formatters';

export const VARIAVEL_DA_CLAUSULA_PS = '{{ oportunidade.proposta.clausulaPS }}';

/** A 2.1 do modelo 1 ("Contrato IPCOM Cloud") como está gravada, com as variáveis ainda cruas. */
const FRASE_PS_DO_MODELO = /O valor total dos produtos e serviços \(P&(?:amp;)?S\) contratados será de \{\{ oportunidade\.propostaMaisNova\.valor\|moeda\(2, oportunidade\.propostaMaisNova\.moeda\) \}\}, pago em \{\{ oportunidade\.proposta\.parcelas \}\} parcelas iguais, com vencimento da primeira parcela em até 07 \(sete\) dias após o envio da NF-e, e as demais a cada 30 \(trinta\) dias subsequentes\./g;

export const FRASE_PS_ISENTO = 'A ativação dos serviços é isenta, em razão de desconto integral (100%) concedido pela CONTRATADA.';

/** Moeda do contrato: pt-BR com milhar, aceitando o texto que o backend devolve. */
export const moedaDoContrato = (v: number | string | null | undefined): string => fmtCurrency(v ?? 0);

const valorNumerico = (v: unknown) => { const n = typeof v === 'number' ? v : parseFloat(String(v ?? '')); return Number.isFinite(n) ? n : 0; };

export function fraseDaClausulaPS(proposal: { totalPS?: number | string | null; installments?: number | string | null }): string {
  if (valorNumerico(proposal?.totalPS) === 0) return FRASE_PS_ISENTO;
  const parcelas = Number(proposal?.installments) || 10;
  const valor = moedaDoContrato(proposal?.totalPS);
  if (parcelas === 1) {
    return `O valor total dos produtos e serviços (P&S) contratados será de ${valor}, pago em parcela única, com vencimento em até 07 (sete) dias após o envio da NF-e.`;
  }
  return `O valor total dos produtos e serviços (P&S) contratados será de ${valor}, pago em ${parcelas} parcelas iguais, com vencimento da primeira parcela em até 07 (sete) dias após o envio da NF-e, e as demais a cada 30 (trinta) dias subsequentes.`;
}

/** Troca a 2.1 (a frase gravada no modelo, ou a variável nova) antes das substituições simples. */
export function aplicarClausulaPS(template: string, proposal: any): string {
  const frase = fraseDaClausulaPS(proposal);
  return template.replace(FRASE_PS_DO_MODELO, () => frase).split(VARIAVEL_DA_CLAUSULA_PS).join(frase);
}
